'use client'

import { LoginPageComponent } from '@/components/auth/login/login-page-component'

export default function LoginPage() {
  return <LoginPageComponent />
}